import _regenerator from "D:/WebBuild/teamCity/buildAgent/work/f0b2174a44415a20/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "D:/WebBuild/teamCity/buildAgent/work/f0b2174a44415a20/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
export default {
  name: "create",
  data: function data() {
    return {
      form: {},
      rules: {},
      loading: false
    };
  },
  methods: {
    submit: function submit() {
      var _this = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              _context.n = 1;
              return _this.$checkForm();
            case 1:
              _this.$emit('submit');
            case 2:
              return _context.a(2);
          }
        }, _callee);
      }))();
    },
    cancel: function cancel() {
      this.$emit('cancel');
    }
  }
};